// @AddIntl

import { assertNever, langParams, Locale } from '@repo/utils'
import React from 'react'

import { useLocale } from '../../../../hooks/use-locale'
import Icon from '../../../atoms/icons/icon/Icon'

type RenderFlagTriggerProps = {
  labelSize: 'short' | 'long'
}

export function RenderFlagTrigger({ labelSize }: RenderFlagTriggerProps) {
  const { locale } = useLocale()
  const labels: Record<RenderFlagTriggerProps['labelSize'], string> = {
    short: locale.split('-')[0].toUpperCase(),
    long: langParams[locale].langLabel,
  }

  return (
    <span
      title={labels['long']}
      className='flex items-center gap-1 leading-none'
    >
      <ResolveFlag locale={locale} />
      {labels[labelSize]}
    </span>
  )
}

function ResolveFlag({ locale }: { locale: Locale }) {
  switch (locale) {
    case 'de-de':
      return <Icon name='germany-flag' size={20} />
    case 'en-gb':
      return <Icon name='uk-flag' size={20} />
    case 'es-es':
      return <Icon name='spain-flag' size={20} />
    case 'fr-fr':
      return <Icon name='french-flag' size={20} />
    case 'fr-be':
      return <Icon name='belgium-flag' size={20} />
    case 'it-it':
      return <Icon name='italy-flag' size={20} />
    case 'nl-be':
      return <Icon name='belgium-flag' size={20} />
    case 'nl-nl':
      return <Icon name='netherland-flag' size={20} />
    default:
      assertNever(locale)
  }
}
